/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Organize_FilesInputs */

const en_dialog_organize_files = /** @type {(inputs: Dialog_Organize_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organize your files in folders`)
};

const es_dialog_organize_files = /** @type {(inputs: Dialog_Organize_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organiza tus archivos en carpetas`)
};

/**
* | output |
* | --- |
* | "Organize your files in folders" |
*
* @param {Dialog_Organize_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_organize_files = /** @type {((inputs?: Dialog_Organize_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Organize_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_organize_files(inputs)
	return en_dialog_organize_files(inputs)
});